import { PropsWithChildren, Suspense } from "react"
import {
  cn,
  NavigationMenuRoutes,
  NavigationMenuWrapper,
  ProfileDropdown,
  Skeleton,
} from "toptaal-shared"
import { TRoutes } from "@/types/routes"
import {
  useCurrentStudentSuspenseQuery,
  useNotificationCountQuery,
  useLogout,
} from "students-api"
import { BellIcon, UserIcon } from "@heroicons/react/24/outline"
import { Link, useRouter } from "@tanstack/react-router"

const navigationItems: NavigationMenuRoutes<TRoutes>[] = [
  { label: "Home", path: "/home" },
  { label: "Agenda", path: "/agenda" },
  { label: "Correspondentie", path: "/correspondentie" },
]

interface ScreenWrapperProps extends PropsWithChildren {
  className?: string
}

export default function ScreenWrapper({
  children,
  className,
}: ScreenWrapperProps) {
  const { data: notificationCount = 0 } = useNotificationCountQuery()
  const displayNotificationCount =
    notificationCount > 99 ? "99+" : notificationCount

  return (
    <>
      <NavigationMenuWrapper
        navigationItems={navigationItems}
        profileDropdown={
          <div className="flex items-center gap-4">
            <Suspense fallback={<Skeleton className="h-8 w-32" />}>
              <NavigationContent />
            </Suspense>
            <Link
              to="/meldingen"
              className="relative flex size-6 items-center justify-center rounded-full bg-primary-dark-blue text-primary-text-on-bg"
            >
              <BellIcon className="size-4" />
              {notificationCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-secondary-coral rounded-full size-6 flex items-center justify-center text-[10px] leading-none text-primary-text-on-bg font-bold">
                  {displayNotificationCount}
                </span>
              )}
            </Link>
          </div>
        }
      />

      <div className={cn("screen-container", className)}>{children}</div>
    </>
  )
}

function NavigationContent() {
  const { logout } = useLogout()
  const router = useRouter()

  const { data: user, isLoading } = useCurrentStudentSuspenseQuery()

  const handleLogout = () => {
    logout()

    router.navigate({ to: "/login" })
  }

  return (
    <ProfileDropdown
      firstName={user.firstName}
      lastName={user.lastName}
      isLoading={isLoading}
      variant="student"
      menuItems={[
        {
          label: "Profiel",
          path: "/profiel/persoonlijke_gegevens",
          icon: UserIcon,
        },
      ]}
      onLogout={handleLogout}
    />
  )
}
